import template from './copy-btn.html';
export default angular
  .module('doxy.common.components.copyBtn', [])
  .component('copyBtn', {
    template,
    bindings: {
      target: '@',
    },
    controller: function ($timeout, $q, trackingFactory) {
      this.onClick = () => {
        this.copyPromise = null;
        const el = document.querySelector(this.target);
        window.Clipboard.copy(el.value || el.textContent);
        const deferrer = $q.defer(0);
        this.copyPromise = deferrer.promise;
        $timeout(() => {
          deferrer.resolve();
        }, 0);
        trackingFactory.global.trackButtonClick({
          button_action: 'copy room link',
          button_text: 'copy',
          button_type: 'button',
          context: null,
        });
      };
    },
  }).name;
